import { render, staticRenderFns } from "./requestInfo.vue?vue&type=template&id=d27e3880&scoped=true"
import script from "./requestInfo.vue?vue&type=script&lang=js"
export * from "./requestInfo.vue?vue&type=script&lang=js"
import style0 from "./requestInfo.vue?vue&type=style&index=0&id=d27e3880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e3880",
  null
  
)

export default component.exports